import React from 'react';
import { Platform, Text, useWindowDimensions } from 'react-native';
import styled from 'styled-components/native';
import AlertBox from '../../../components/AlertBox';
import Button from '../../../components/Button';
import Spacer from '../../../components/Spacer';
import { H5, P } from '../../../components/Typography';
import { StudyParticipant } from '../../../models/StudyParticipant';
import { useStudyContext } from '../../../context/StudyContext';
import { StackNavigationProp } from '@react-navigation/stack';
import { useNavigation } from '@react-navigation/core';

const StyledCardView = styled.View<{
  isDesktop: boolean;
}>`
  width: 100%;
  background-color: rgb(140, 83, 138);
  border-radius: 8px;
  flex-grow: 1;
  width: ${p => (Platform.OS === 'web' && p.isDesktop ? 'auto' : '100%')};
  height: auto;
  padding: 22px 18px;
`;

const StudyStartCard: React.FC<{
  studyErrors: string[];
  studyParticipant: StudyParticipant;
}> = ({ studyErrors, studyParticipant }) => {
  const { studyIntake } = useStudyContext();
  const window = useWindowDimensions();
  const isLargeDesktop = window.width >= 1200;
  const navigation = useNavigation<StackNavigationProp<any>>();

  const handleEdit = (dataSourceFields: string[]) => {
    navigation.push('FormTemplate', {
      formTemplateId: studyIntake?.formTemplateId,
      entityDataId: studyIntake?.id,
      dataSourceFields: JSON.stringify(dataSourceFields)
    });
  };

  return (
    <StyledCardView isDesktop={isLargeDesktop}>
      <H5 color='light' padding={1}>
        Start the Study
      </H5>
      {studyErrors.length > 0 ? (
        <>
          <P color='light' padding={2}>
            You can&apos;t start the study just yet. There are a few more things
            that need to be completed first.
          </P>
          <AlertBox severity='error'>
            {studyErrors.map((error, index) => (
              <Text key={index}>{`${error}${
                index < studyErrors.length - 1 ? '\n' : ''
              }`}</Text>
            ))}
          </AlertBox>
        </>
      ) : (
        <P color='light'>
          You haven&apos;t started the study yet. If you are ready, let&apos;s
          go ahead and get started.
        </P>
      )}
      <Spacer size='medium' />
      <Button
        inverse
        outlined
        disabled={
          studyErrors.length > 0 || Boolean(studyParticipant?.startDate)
        }
        onPress={() => handleEdit([])}
      >
        Start the Study
      </Button>
    </StyledCardView>
  );
};

export default StudyStartCard;
